const styleSheet = () => ({
  filterSliderContainer: {
    height: '56px',
    width: '308px',
    marginLeft: '1px',
  },
  filterSlider: {
    width: '174px',
  },
  values: {
    height: '15px',
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.5px',
    lineHeight: '15px',
    marginBottom: '15px',
  },
  sliderContainer: {
    position: 'absolute',
    width: '174px',
    "& input[type='range']": {
      '-webkit-appearance': 'none',
      width: '100%',
      background: 'transparent',
      pointerEvents: 'none',
    },
    "& input[type='range']::-webkit-slider-runnable-track": {
      zIndex: 9,
    },
    "& input[type='range']::-moz-range-track": {
      width: '100%',
      background: 'transparent',
      zIndex: 9,
    },
    '& input[type=range]::-ms-track': {
      width: '100%',
      background: 'transparent',
      borderColor: 'transparent',
      color: 'transparent',
    },
    "& input[type='range']::-webkit-slider-thumb": {
      '-webkit-appearance': 'none',
      zIndex: 9,
      pointerEvents: 'all',
      cursor: 'pointer',
      boxSizing: 'border-box',
      height: '20px',
      width: '20px',
      border: '1.5px solid #D8DCE6',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
      borderRadius: '50%',
      marginTop: '-24px',
    },
    "& input[type='range']::-moz-range-thumb": {
      '-moz-appearance': 'none',
      zIndex: 9,
      pointerEvents: 'all',
      cursor: 'pointer',
      boxSizing: 'border-box',
      height: '20px',
      width: '20px',
      border: '1.5px solid #D8DCE6',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
      borderRadius: '50%',
      transform: 'translateY(-6px)',
    },
    "& input[type='range']::-ms-thumb": {
      zIndex: 9,
      pointerEvents: 'all',
      cursor: 'pointer',
      boxSizing: 'border-box',
      height: '20px',
      width: '20px',
      border: '1.5px solid #D8DCE6',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)',
      borderRadius: '50%',
      // May need to be changed, I cant see IE to test.
      marginTop: '-24px',
    },
  },
  railContainer: {
    width: '174px',
    position: 'relative',
  },
  inactiveRailRight: {
    zIndex: 3,
    position: 'absolute',
    right: 0,
    height: '3px',
    borderRadius: '1px',
    backgroundColor: '#D8DCE6',
  },
  inactiveRailLeft: {
    zIndex: 3,
    position: 'absolute',
    left: 0,
    height: '3px',
    borderRadius: '1px',
    backgroundColor: '#D8DCE6',
  },
  activeRail: {
    zIndex: 1,
    position: 'absolute',
    height: '3px',
    width: '174px',
    borderRadius: '1px',
    backgroundColor: (props: any) => (props.color && props.color) || '#085FE5',
  },
});

export default styleSheet;
